import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SanitizationHelper {
  constructor(private sanitizer: DomSanitizer) {}

  sanitizeText(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  sanitizeObject(obj: any): any {
    const sanitizedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string' && obj[key].includes('data-document-id')) {
          sanitizedObj[key] = this.sanitizeText(obj[key]);
        }
        // else if (typeof obj[key] === 'object' && obj[key] !== null) {
        //   sanitizedObj[key] = this.sanitizeObject(obj[key]);
        // }
        else {
          sanitizedObj[key] = obj[key];
        }
      }
      // if (obj.hasOwnProperty(key)) {
      //   if (typeof obj[key] === 'string') {
      //     sanitizedObj[key] = this.sanitizeText(obj[key]);
      //   } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      //     sanitizedObj[key] = this.sanitizeObject(obj[key]);
      //   } else {
      //     sanitizedObj[key] = obj[key];
      //   }
      // }
    }
    return sanitizedObj;
  }
}
